export default "__VITE_ASSET__1c70e211__"